import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ActionConfirmModal from '../../common/components/actionConfirmModal';
import PermissaoUsuario from '../../auth/permissao';
import { showUpdate, showMembros, remove, setPaginaAtual } from './equipeActions';
import SPButton from '../../common/form/spButton';
import ReactTableGT2A from '../../common/grid/gridReactTable';
import PremiumTableShell from '../../common/grid/premiumTableShell';
import { filtrarPorAtivo, filtrarPorTexto, renderSituacaoBadge } from '../manutencaoListUtils';

const FILTRO_TODOS = '';

class EquipeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtroBusca: '',
      filtroAtivo: FILTRO_TODOS,
      excluirEquipe: null,
    };
    this.removerEquipe = this.removerEquipe.bind(this);
    this.confirmarExclusaoEquipe = this.confirmarExclusaoEquipe.bind(this);
    this.cancelarExclusaoEquipe = this.cancelarExclusaoEquipe.bind(this);
    this.handleBuscaChange = this.handleBuscaChange.bind(this);
    this.handleAtivoChange = this.handleAtivoChange.bind(this);
  }

  handleBuscaChange(event) {
    this.setState({ filtroBusca: event.target.value });
    this.props.setPaginaAtual(0);
  }

  handleAtivoChange(event) {
    this.setState({ filtroAtivo: event.target.value });
    this.props.setPaginaAtual(0);
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  removerEquipe(data) {
    this.setState({ excluirEquipe: data });
  }

  confirmarExclusaoEquipe() {
    const { excluirEquipe } = this.state;
    if (!excluirEquipe) return;
    this.props.remove(excluirEquipe);
    this.setState({ excluirEquipe: null });
  }

  cancelarExclusaoEquipe() {
    this.setState({ excluirEquipe: null });
  }

  renderFiltros() {
    const { filtroBusca, filtroAtivo } = this.state;

    return (
      <div className="os-list-filters-bar">
        <div className="os-list-filter-group os-list-filter-group--search">
          <label className="os-list-filter-label" htmlFor="equipe-list-filtro-busca">
            Buscar
          </label>
          <input
            id="equipe-list-filtro-busca"
            type="search"
            className="form-control os-list-filter-input"
            value={filtroBusca}
            onChange={this.handleBuscaChange}
            placeholder="Nome da equipe..."
          />
        </div>
        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="equipe-list-filtro-ativo">
            Situação
          </label>
          <select
            id="equipe-list-filtro-ativo"
            className="form-control os-list-filter-select"
            value={filtroAtivo}
            onChange={this.handleAtivoChange}
          >
            <option value={FILTRO_TODOS}>Todas</option>
            <option value="1">Ativas</option>
            <option value="0">Inativas</option>
          </select>
        </div>
      </div>
    );
  }

  render() {
    const equipes = this.props.list || [];
    const equipesFiltradas = filtrarPorAtivo(
      filtrarPorTexto(equipes, ['nome'], this.state.filtroBusca),
      this.state.filtroAtivo,
    );

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div className="os-actions-cell">
            <div className="os-actions-group">
              <PermissaoUsuario tela="CadManutencaoEquipe" campo="membros" condicao={true}>
                <SPButton
                  type="button"
                  className="info btn-sm"
                  icon="user-friends"
                  data-title="Membros"
                  onClick={() => this.props.showMembros(row.original)}
                />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoEquipe" campo="alterar" condicao={true}>
                <SPButton
                  type="button"
                  className="warning btn-sm"
                  icon="pencil-alt"
                  data-title="Alterar"
                  onClick={() => this.props.showUpdate(row.original)}
                />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadManutencaoEquipe" campo="excluir" condicao={true}>
                <SPButton
                  type="button"
                  className="danger btn-sm"
                  icon="trash-alt"
                  data-title="Excluir"
                  onClick={() => this.removerEquipe(row.original)}
                />
              </PermissaoUsuario>
            </div>
          </div>
        ),
        className: 'column_icon',
        width: 108,
        resizable: false,
        sortable: false,
        filterable: false,
      },
      {
        Header: 'Código',
        accessor: 'id',
        width: 80,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => <span className="os-cell-numero">{row.value}</span>,
      },
      {
        Header: 'Nome',
        accessor: 'nome',
        minWidth: 200,
        className: 'column_grid manutencao-col-texto',
        filterable: false,
        Cell: row => <span className="os-cell-ellipsis">{row.value}</span>,
      },
      {
        Header: 'Membros',
        accessor: 'total_membros',
        width: 90,
        className: 'column_grid column_center',
        filterable: false,
      },
      {
        Header: 'Viaturas',
        accessor: 'total_viaturas',
        width: 90,
        className: 'column_grid column_center',
        filterable: false,
      },
      {
        Header: 'Situação',
        accessor: 'ativo',
        width: 100,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => renderSituacaoBadge(row.value),
      },
    ];

    return (
      <div className="manutencao-premium-list table-container">
        <div className="os-list-top-panel">
          <p className="os-list-summary">{`${equipesFiltradas.length} equipe(s)`}</p>
          {this.renderFiltros()}
        </div>
        <PremiumTableShell summary="" hideToolbar tableMinWidth={0}>
          <ReactTableGT2A
            data={equipesFiltradas}
            columns={columns}
            className="-striped -highlight"
            defaultPageSize={15}
            showPagination
            filterable={false}
            onPageChange={this.handlePageChange}
            page={this.props.paginaAtual}
            minRows={0}
          />
        </PremiumTableShell>

        <ActionConfirmModal
          show={!!this.state.excluirEquipe}
          title="Deseja realmente excluir?"
          message="A equipe e seus vínculos serão removidos permanentemente do cadastro."
          itemName={this.state.excluirEquipe ? this.state.excluirEquipe.nome : ''}
          confirmLabel="Excluir"
          destructive
          icon="trash-alt"
          onConfirm={this.confirmarExclusaoEquipe}
          onCancel={this.cancelarExclusaoEquipe}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.manutencaoEquipe.list,
  paginaAtual: state.manutencaoEquipe.paginaAtual,
});
const mapDispatchToProps = dispatch => bindActionCreators({ showUpdate, showMembros, remove, setPaginaAtual }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EquipeList);
